<template>
    <div class="container mx-auto py-8">
        <div class="flex flex-col md:flex-row gap-8">
            <!-- Left Column: Member Image -->
            <div class="w-full text-center">
                <img :src="member.image" alt="Member Image"
                    class="w-48 h-48 mx-auto object-cover rounded-full border-4 border-green-900" />
                <h2 class="text-3xl font-semibold text-gray-900 mt-6">{{ member.name }}</h2>
                <p class="text-lg text-gray-600 mb-4">{{ member.uniqueId }}</p>

                <!-- Bio Section -->
                <div class="mb-6">
                    <h3 class="text-xl font-semibold text-gray-800">About</h3>
                    <p class="text-gray-600">{{ member.about }}</p>
                </div>

                <!-- Joining Date -->
                <div>
                    <h3 class="text-xl font-semibold text-gray-800">Joining Date</h3>
                    <p class="text-gray-600">{{ formattedJoiningDate }}</p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            member: {
                name: "",
                uniqueId: "",
                about: "",
                joiningDate: "",
                image: "",
            },
        };
    },
    computed: {
        // Format joining date to Dec 31, 2024
        formattedJoiningDate() {
            if (!this.member.joiningDate) return "Not available";
            const date = new Date(this.member.joiningDate);
            const options = { year: "numeric", month: "short", day: "numeric" };
            return date.toLocaleDateString("en-US", options);
        },
    },
    async created() {
        await this.fetchMemberDetails();
    },
    methods: {
        async fetchMemberDetails() {
            try {
                // Fetch member details from the API
                const memberCode = this.$route.params.member_code; // Assuming `member_code` is passed as a route param
                const BASE_URL = this.$root.BASE_URL;
                const response = await fetch(`${BASE_URL}/api/member/${memberCode}`);
                const data = await response.json();

                // Map API data to component's data structure
                this.member = {
                    name: data.name || "Unknown",
                    uniqueId: data.member_code || "N/A",
                    about: data.bio || "Bio not available",
                    joiningDate: data.created_at || null,
                    image: `${BASE_URL}/members/images/${data.profile_pic}`,
                };
            } catch (error) {
                console.error("Error fetching member details:", error);
            }
        },
    },
};
</script>

<style scoped>
/* Styling for the Member Details Page */
.container {
    max-width: 1200px;
}

img {
    transition: transform 0.3s ease;
}

img:hover {
    transform: scale(1.05);
}

h2 {
    color: #1f2937;
    /* Dark gray */
}

h3 {
    color: #374151;
    /* Slightly lighter gray */
}
</style>
